// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/regional-component-lists/detail-form/detail-form.css
// module id = 4193
// module chunks = 0